export const analog_input_id = 20550;
export const user_id = 20533;
export const notification_low_balance_id = 20534;
export const notification_lost_power_id = 20535;
export const notification_find_power_id = 20536;
export const notification_connection_lost_id = 20537;
export const notifications_boiler_error_id = 20538;
export const boiler_adapter_id = 20600;
export const relay_id = 20488;
export const hc_boiler_id = 20494;
export const hc_id = 20496;
export const hc_dhw_id = 20603;
export const hc_reserve_id = 20604;
export const hm_comfort_id = 20501;
export const hm_economy_id = 20502;
export const hm_schedule_id = 20503;
export const hm_off_id = 20504;
export const hm_summer_id = 20505;
export const hm_reserve_id = 20605;
export const command_on_id = 20601;
export const command_off_id = 20602;
export const consumer_timetable_id = 20706;
export const consumer_ti_id = 20716;
export const dhw_timetable_id = 20707;
export const dhw_ti_id = 20717;
export const boiler_with_reserve_timetable_id = 20806;
export const boiler_with_reserve_ti_id = 20816;
export const reserve_boiler_timetable_id = 20807;
export const reserve_boiler_ti_id = 20817;
//For esp devices
export const io_extensions_id = 20551;
export const ntc_curve_id = 20651;
export const ats_water_id = 20560;
export const ats_air_id = 20561;
